import { Text } from 'components/Typography';
import { Link } from 'components/Link';
import { ReactNode } from 'react';
import { NodeRendererType } from '@graphcms/rich-text-react-renderer';

export const Primitives: NodeRendererType = {
  p: ({ children }: { children: ReactNode }) => (
    <>
      <Text type="md" tag={'p'}>
        {children}
      </Text>
    </>
  ),
  bold: ({ children }: { children: ReactNode }) => <b>{children}</b>,
  italic: ({ children }: { children: ReactNode }) => <i>{children}</i>,
  underline: ({ children }: { children: ReactNode }) => <u>{children}</u>,
  a: ({ href, children }: { children: ReactNode; href?: string }) => (
    <>{!!href && <Link href={href}>{children}</Link>}</>
  ),
  video: () => <></>,
  iframe: () => <></>,
  ul: () => <></>,
  ol: () => <></>,
  li: () => <></>,
  Asset: {
    audio: () => <></>,
    image: ({ alt, url, ...rest }) => (
      <img src={url} alt={alt || 'Image'} altText={alt || 'Image'} {...rest} />
    ),
    video: () => <></>,
  },
  list_item_child: () => <></>,
  embed: {},
  img: () => <></>,
  h1: () => <></>,
  h2: () => <></>,
  h3: () => <></>,
  h4: () => <></>,
  h5: () => <></>,
  h6: () => <></>,
  table: () => <></>,
  table_head: () => <></>,
  table_body: () => <></>,
  table_row: () => <></>,
  table_cell: () => <></>,
  table_header_cell: () => <></>,
  class: () => <></>,
  code: () => <></>,
  code_block: () => <></>,
  blockquote: ({ children }) => <blockquote>{children}</blockquote>,
};
